import { ReactNode } from "react";
import Link from "next/link";
import { useTranslation } from "next-i18next";
import { useArticlesPageContext } from "@/src/features/articles/ArticlesPageContext";
import { useAppContext } from "@/src/config/AppProvider";

const ArticlesHeadSection = (): ReactNode => {
  const { t } = useTranslation();
  const { totalCount } = useArticlesPageContext();
  const { getLocalization } = useAppContext();

  return (
    <div className="rbt-page-banner-wrapper">
      <div className="rbt-banner-image"></div>
      <div className="rbt-banner-content">
        <div className="rbt-banner-content-top">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <ul className="page-list">
                  <li className="rbt-breadcrumb-item">
                    <Link href="/">{t("homePage")}</Link>
                  </li>
                  <li>
                    <div className="icon-right">
                      <i className="feather-chevron-right"></i>
                    </div>
                  </li>
                  <li className="rbt-breadcrumb-item active">{t("articles")}</li>
                </ul>
                <div className=" title-wrapper">
                  <h1 className="title mb--0">{t("allArticles")}</h1>
                  <div className="rbt-badge-2">
                    {t("@articles", {
                      0: totalCount
                    })}
                  </div>
                </div>
                <p className="description">{getLocalization("newArticlesSlogan")}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArticlesHeadSection;
